/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NftCollection } from './NftCollection';
import {
    NftCollectionFromJSON,
    NftCollectionFromJSONTyped,
    NftCollectionToJSON,
} from './NftCollection';

/**
 * 
 * @export
 * @interface NftGate
 */
export interface NftGate {
    /**
     * Must hold an NFT of the given collection to unlock
     * @type {NftCollection}
     * @memberof NftGate
     */
    nftCollection: NftCollection;
}

/**
 * Check if a given object implements the NftGate interface.
 */
export function instanceOfNftGate(value: object): value is NftGate {
    let isInstance = true;
    isInstance = isInstance && "nftCollection" in value && value["nftCollection"] !== undefined;

    return isInstance;
}

export function NftGateFromJSON(json: any): NftGate {
    return NftGateFromJSONTyped(json, false);
}

export function NftGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftGate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nftCollection': NftCollectionFromJSON(json['nft_collection']),
    };
}

export function NftGateToJSON(value?: NftGate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nft_collection': NftCollectionToJSON(value.nftCollection),
    };
}

